import { trpc } from "../main/components/ProviderContainer.tsx";
import SlashDateFrenchDisplay from "../utils/components/SlashDateFrenchDisplay.tsx";
import { DateTime } from "luxon";
import { integerCentToFrenchFinanString } from "vincent-utils";

interface AllLoansPanelProps {
  onSelectLoan: (loanId: string) => void;
  selectedLoanId: string | null;
  yearSelected: number;
}
const AllLoansPanel = ({
  onSelectLoan,
  selectedLoanId,
  yearSelected,
}: AllLoansPanelProps) => {
  const { data } = trpc.loan.getAll.useQuery();
  const loans = data || [];
  const currentYear = yearSelected;

  const loansWithCurrentYearTotals = loans.map((loan) => {
    const currentYearPrincipalCent = loan.payments.reduce(
      (loanTotal, payment) => {
        const paymentYear = DateTime.fromJSDate(new Date(payment.date)).year;
        if (paymentYear !== currentYear) {
          return loanTotal;
        }

        return loanTotal + payment.principalCent;
      },
      0,
    );

    const currentYearInterestCent = loan.payments.reduce(
      (loanTotal, payment) => {
        const paymentYear = DateTime.fromJSDate(new Date(payment.date)).year;
        if (paymentYear !== currentYear) {
          return loanTotal;
        }

        return loanTotal + payment.interestCent;
      },
      0,
    );

    return {
      loan,
      currentYearPrincipalCent,
      currentYearInterestCent,
    };
  });

  const currentYearPrincipalCent = loansWithCurrentYearTotals.reduce(
    (total, loanWithTotals) => total + loanWithTotals.currentYearPrincipalCent,
    0,
  );

  const currentYearInterestCent = loansWithCurrentYearTotals.reduce(
    (total, loanWithTotals) => total + loanWithTotals.currentYearInterestCent,
    0,
  );

  return (
    <div>
      <div className="row mt-2">
        <div className="col col-md-auto">
          <div className="card">
            <div className="card-header">Tous les emprunts</div>
            <div className="card-body">
              <p className="mb-1">
                Total capital remboursé en {currentYear}:{" "}
                {integerCentToFrenchFinanString(currentYearPrincipalCent)} €
              </p>
              <p className="mb-3">
                Total intérêts remboursés en {currentYear}:{" "}
                {integerCentToFrenchFinanString(currentYearInterestCent)} €
              </p>
              <table className="table">
                <thead>
                  <tr>
                    <th>Date début</th>
                    <th>Nom</th>
                    <th>Capital initial</th>
                    <th>Durée</th>
                    <th>Capital remboursé {currentYear}</th>
                    <th>Intérêts remboursés {currentYear}</th>
                  </tr>
                </thead>
                <tbody>
                  {loansWithCurrentYearTotals.map((loanWithTotals) => {
                    const { loan } = loanWithTotals;

                    return (
                      <tr
                        key={loan._id}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          onSelectLoan(loan._id as string);
                        }}
                        className={
                          loan._id === selectedLoanId
                            ? "table-primary"
                            : "table-default"
                        }
                      >
                        <td>
                          <SlashDateFrenchDisplay date={loan.startDate} />
                        </td>

                        <td>{loan.name}</td>
                        <td>{loan.principalCent} </td>
                        <td>{loan.months + " mois"}</td>
                        <td>
                          {integerCentToFrenchFinanString(
                            loanWithTotals.currentYearPrincipalCent,
                          )}{" "}
                          €
                        </td>
                        <td>
                          {integerCentToFrenchFinanString(
                            loanWithTotals.currentYearInterestCent,
                          )}{" "}
                          €
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllLoansPanel;
